import { LoadingIndicator } from "@/shared/components/LoadingIndicator";
import { lazyLoad } from "@/shared/utils/loadable";

export const MyFarmPage = lazyLoad(
  () => import("./index"),
  (module) => module.default,
  { fallback: <LoadingIndicator fullPageHeight /> }
);
